export const neckMoveText = {
  values: [
    { value: 'NeckMove', text: 'Ja', score: 1 },
    { value: 'NeckMove', text: 'Nei', score: 0 },
  ],
};
